export default "__VITE_ASSET__CvfYGqlE__"